import PageSeo from '@/seo/PageSeo';
import Enrichment from '../modules/enrichment/Enrichment';

export default function EnrichmentPage() {
  return (
    <>
      <PageSeo
        title="Disease Enrichment Analysis | DISGENET"
        description="Run gene-disease enrichment analysis on gene or variant lists to identify disease associations from curated DISGENET evidence."
        path="/enrichment"
      />
      <div className="advanced-research container-view md:p-4">
        <div className="search-results-container">
          <Enrichment />
        </div>
      </div>
    </>
  );
}
